import React, { useEffect, useState } from "react";
import './MainContent.css';
import { Link } from 'react-router-dom';
import Bubble1 from '../Assets/Bubble_1.png';
import Bubble2 from '../Assets/Bubble_2.png';
import Bubble3 from '../Assets/Bubble_3.png';
import Bubble4 from '../Assets/Bubble_4.png';
import Bubble5 from '../Assets/Bubble_5.png';
import { LoadingMessages } from '../../Utilities/LoadingMessages.jsx';

const MainContent = () => {
  const [loading, setLoading] = useState(true); 
  const [isAnimating, setIsAnimating] = useState(false);

  

  useEffect(() => {
    let mounted = true;
    const images = [Bubble1, Bubble2, Bubble3, Bubble4, Bubble5];
    
    // Check cached images first
    const allCached = images.every(src => {
      const img = new Image();
      img.src = src;
      return img.complete;
    });

    if (allCached) {
      if (mounted) {
        setIsAnimating(true);
        setLoading(false);
      }
      return;
    }

    // Set up load listeners for uncached images
    const imagePromises = images.map(src => {
      return new Promise(resolve => {
        const img = new Image();
        img.src = src;
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve; // Don't block on errors
        }
      });
    });

    // Fallback timeout
    const timeout = setTimeout(() => {
      if (mounted) {
        setIsAnimating(true);
        setLoading(false);
      }
    }, 1000);

    Promise.all(imagePromises)
      .then(() => {
        clearTimeout(timeout);
        if (mounted) {
          setIsAnimating(true);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
      clearTimeout(timeout);
    };
  }, []);

  const handleBubbleClick = () => {
    console.log("Bubble clicked");
  };

  if (loading) {
        return (
          <div className="creative-loading">
            <LoadingMessages />
          </div>
        );
      }

  return (
     
    <div className="mainContent">
      <div className={`container ${isAnimating ? "animate" : ""}`}>
        <div className="box">
          <Link to="/hookc" onClick={handleBubbleClick}>
            <img src={Bubble3} className="Bubble_3" alt="Bubble 1" />
          </Link>
        </div>
        <div className="box">
          <Link to="/hookb" onClick={handleBubbleClick}>
            <img src={Bubble2} className="Bubble_2" alt="Bubble 2" />
          </Link>
        </div>
        <div className="box">
          <Link to="/hook" onClick={handleBubbleClick}>
            <img src={Bubble1} className="Bubble_1" alt="Bubble 3" />
          </Link>
        </div>
        <div className="box">
          <Link to="/sat" onClick={handleBubbleClick}>
            <img src={Bubble4} className="Bubble_4" alt="Bubble 4" />
          </Link>
        </div>
        <div className="box">
          <Link to="/cgi" onClick={handleBubbleClick}>
            <img src={Bubble5} className="Bubble_5" alt="Bubble 5" />
          </Link>
        </div>
        <div className="box">
          <Link to="/hook" onClick={handleBubbleClick}>
            <img src={Bubble1} className="Bubble_6" alt="Bubble 1" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MainContent;